export const aboutTabsItems = {
  myStory: {
    tabName: "My Story",
    tabPanel: [
      {
        id: "myStory1",
        title: "About Me",
        degree: "",
        timeframe: "",
        description:
          "Former Immunology PhD candidate-turned aspiring developer, who is interested in pursuing a career within the tech field. Learning how to program has been a truly exciting experience, and has given me a largely different perspective on how I see the technology I interact with. I had always been fond of technology and programming, and I had even become expected to start learning R and Python towards the end of my tenure as a doctoral student. After taking some time to look into programming, I was not only fascinated with the logic behind how programming works, but with how much in-depth material is available on the web. My newfound fascination of technology, rigorous academic background and drive to enter the field of programming had eventually led me to leaving my PhD programming with the pursuit of becoming a professional programmer.",
      },
    ],
  },

  educationItems: {
    tabName: "Education",
    tabPanel: [
      {
        id: "education1",
        title: "Self-Taught",
        degree: "N/A",
        timeframe: "January 2021 - Present",
        description: "Since  starting my self-taught journey. I've spent significant time studying concepts and technologies relating to IT, web development, data analysis and mathematics. Thanks to the contribution of countless professionals, content creators and hobbyists in the field, I've been able to apply my rigourous study habits and passion for education to learn and apply both notable and emerging technologies."
      },
      {
        id: "education2",
        title: "Albany Medical College",
        degree: "PhD Immunology & Microbial Diseases (Withdrawn)",
        timeframe: "August 2018 - May 2021",
        description: "My first year attending the Immunology and Microbial Disease doctoral program was spent rotating in labs, whose focused ranged from bacterial diseases, like Tuberculosis, to the neurological disease Alzheimer's. Eventually, I had decided to join Dr. Katherine MacNamara's lab, in which I studied the effects of tick-borne diseases on hematopoiesis (the process of producing blood cells) throughout the duration of my tenure.",
      },
      {
        id: "education3",
        title: "College of Saint Rose",
        degree: "BS Biology + Minor Chemistry (Completed)",
        timeframe: "August 2014 - May 2018",
        description: "My 4-year period at Saint Rose is when I truly began acting on my passion for academics and natural sciences, and took great pride in it. In addition to my required coursework, I was president of the Minority Association of Pre-medical Students (MAPS), while also conducting research on antibiotic resistant in bacteria. I eventually graduated Saint Rose, having attained a BS in Biology, and minor in Chemistry, with cum laude honors.",
      },
    ],
  },

  accolades: {
    tabName: "Accolades",
    tabPanel: [
      {
        id: "accolades1",
        title: "Presentor at New York Immunology Conference",
        degree: "",
        timeframe: "Fall 2019",
        description: "At the annual NYIC, I had presented my research on the effects of hematopoeisis during tick-borne infection.",
      },
      {
        id: "accolades2",
        title: "Research Experience for Undergraduates (REU) Student",
        degree: "",
        timeframe: "June 2017 - August 2017",
        description: "During the Spring of 2017, I had been accepted to a REU program, which is summer research opportunity funded by the National Science Foundation (NSF). My summer here was spent working in the lab of Dr. Katherine McCusker, a developmental biologist whose lab studies the properities of limb regeneration within an amphibian known as the axolotl.",
      },
      {
        id: "accolades3",
        title: "Sigma Xi",
        degree: "",
        timeframe: "Spring 2017",
        description: "Acceptance into Sigma Xi, The Scientific Research Honor Society, for my undergraduate research regarding antibiotic-resistance in common bacteria. This research project lasted approximately 2 years.",
      },
    ],
  },
};
